( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .service( 'ShipmentMinDTOCustomService', ShipmentMinDTOCustomService );

    ShipmentMinDTOCustomService.$inject = [ '$http', '$q' ];

    function ShipmentMinDTOCustomService( $http, $q ) {
        var service = {

        }

        return service;

    }

})();
